export default __webpack_public_path__ + "static/media/20-Annual-Picnic-2021.cd727cf9.jpeg";